import React from 'react';

import { Loader, Spinner } from './SimpleLoader.styles';

const SimpleLoader = (props) => {
    return(
        <Loader>
            <Spinner />
            <span>{props.text}</span>
        </Loader>
    )
}

export default  SimpleLoader;


// WEBPACK FOOTER //
// ./src/components/SimpleLoader/SimpleLoader.Component.tsx